let _isValidKey = function (key) {        
    return (new RegExp("^[^\\x00-\\x20\\x7f\\(\\)<>@,;:\\\\\\\"\\[\\]\\?=\\{\\}\\/\\u0080-\\uffff]+\x24")).test(key);
};

let getRaw = function (key) {
    if (_isValidKey(key)) {
        let reg = new RegExp("(^| )" + key + "=([^;]*)(;|\x24)"),
            result = reg.exec(document.cookie);
            
        if (result) {
            return result[2] || null;
        }
    }

    return null;
};

 
let get = function (key) {
    let value = getRaw(key);
    if ('string' == typeof value) {
        value = decodeURIComponent(value);
        return value;
    }
    return null;
};

let setRaw = function (key, value, options) {
    if (!_isValidKey(key)) {
        return;
    }
    
    options = options || {};
    
    // 计算cookie过期时间
    let expires = options.expires;
    if ('number' == typeof options.expires) {
        expires = new Date();
        expires.setTime(expires.getTime() + options.expires);
    }
    
    document.cookie =
        key + "=" + value
        + (options.path ? "; path=" + options.path : "")
        + (expires ? "; expires=" + expires.toGMTString() : "")
        + (options.domain ? "; domain=" + options.domain : "")
        + (options.secure ? "; secure" : ''); 
};

let remove = function (key, options) {
    options = optionalions || {};
    options.expires = new Date(0);
    setRaw(key, '', options);
};

let set = function (key, value, options) {
    setRaw(key, encodeURIComponent(value), options);
};
let Cookie = {}
export default {
    getRaw: getRaw,
    get: get,
    remove: remove,
    setRaw: setRaw,
    set: set
};


// WEBPACK FOOTER //
// ./src/common/util/cookie.js